var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClockFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0Zm1 4a1 1 0 1 0-2 0v4.92a2 2 0 0 0 1.008 1.736l2.996 1.712a1 1 0 1 0 .992-1.736L10 8.92V4Z",
  clipRule: "evenodd"
})));
export default SvgIconClockFilled;